import {Injectable} from '@angular/core';
import {Communication} from './communication';
import {map} from 'rxjs/operators';
import {
    allowConvert,
    currentSelectedBsk,
    decodeUtf8,
    formatCustomEditor,
    getList,
    getVariableInfo,
    prepareResultValue,
    prepareValue,
} from '@core/_utils/tools.utils';
import {
    defBackGround,
    defLogo,
    ext_Calc,
    ext_Images,
    ext_Mail,
    ext_Pdf,
    ext_Show,
    ext_Text,
    ext_Tiff
} from '@documalis/_const/const';
import {getUrl} from './apiv6.routes';
import {dateFormat} from "@core/_utils/date.utils";

@Injectable()
export class ApiV6Service {
    public bskType: any;
    public bskName: any;
    public bskVariable: any[] = [];
    public bskCurrentSelectedBsk: currentSelectedBsk | null;
    public bskListCount: any[] = [];
    public bskDocList: any;
    public userList: any;
    public bskListAll: any[] = [];
    public currentfilterName: string = '';
    public searchWord: string = '';

    constructor(protected comm: Communication) {
        this.bskCurrentSelectedBsk = null;
        this.bskListCount = [];
        this.bskVariable = [];        
        this.bskDocList = null;
        this.userList = [];
        this.bskListAll = [];
        this.currentfilterName = '';
        this.searchWord = '';
    }

    public execUrlAction(aAction, aData) {
        let wUrl;
        wUrl = getUrl(aAction, aData);
        switch (wUrl.method) {
            case 'patch' : {
                return this.comm.patchUrl(wUrl.url, aData);
            }
            case 'post' : {
                return this.comm.postUrl(wUrl.url, aData);
            }
            case 'delete' : {
                return this.comm.deleteUrl(wUrl.url);
            }
            default : {
                return this.comm.getUrl(wUrl.url);
            }
        }
    }

    public execPostUrlFileAction(aAction, aData) {
        let wUrl;
        wUrl = getUrl(aAction, aData);
        return this.comm.postUrlFile(wUrl.url, aData);
    }

    public getRootPath(aAllRoot, aParam, aApi){
        const formData = new FormData();
        formData.append('allRoot', aAllRoot);
        if (aParam !== null) {
            formData.append('FilterRoot', aParam.root);
            formData.append('FilterPath', aParam.path);
            formData.append('FilterTree', aParam.filterTree);            
        }
        if (aApi === true) {
            return this.execUrlAction('getrootpathapi', formData);
        } else {
            return this.execPostUrlFileAction('getrootpath', formData);
        }
    }
    
    public getRootList(aAllRoot, aParam, aOnlyRoot) {
        return this.execUrlAction('getrootlist', this.getFormData(aAllRoot, aParam, aOnlyRoot));
    }

    public getChildRoot(aAllRoot, aParam, aOnlyRoot) {
        return this.execUrlAction('getchildroot', this.getFormData(aAllRoot, aParam, aOnlyRoot));            
    }

    private getFormData(aAllRoot, aParam, aOnlyRoot) {
        const formData = new FormData();
        formData.append('allRoot', aAllRoot);
        formData.append('onlyRoot', aOnlyRoot);
        if (aParam !== null) {
            formData.append('FilterRoot', aParam.root);
            formData.append('FilterPath', aParam.path);
            formData.append('FilterTree', aParam.filterTree);            
        }
        return formData;
    }

    public getCustomEditorlist() {
        let wInternal: any;
        let wdata: any;
        wInternal = localStorage.getItem('intern');
        if (wInternal) {
            wInternal = JSON.parse(atob(wInternal));
            return this.execUrlAction('getcustomeditorlist',wInternal.internal).pipe(
                map((data: any) => {
                    wdata = this.prepareCustomEditor(data);
                    return wdata;
                })
            );
        } else {
            throw new Error('intern not found');
        }
    }

    public getEditorInfos(aName) {
        let wInternal: any;
        let wdata: any;
        wInternal = localStorage.getItem('intern');
        if (wInternal) {
            wInternal = JSON.parse(atob(wInternal));
            return this.execUrlAction('geteditorinfos', 
                { internal: wInternal.internal,
                  name: aName
                }
            ).pipe(
                map((data: any) => {
                    wdata = this.prepareCustomEditor(data);
                    return wdata;
                })
            );
        } else {
            throw new Error('getEditorInfos : intern not found');
        }
    }

    private prepareCustomEditor(aEditorList){
        if (aEditorList.CustomEditorList.CustomEditor) {
            if (Array.isArray(aEditorList.CustomEditorList.CustomEditor)) {
                aEditorList.CustomEditorList.CustomEditor.map((item) => {
                    formatCustomEditor(item);
                });
            } else {
                formatCustomEditor(aEditorList.CustomEditorList.CustomEditor);
            }
        }
        return aEditorList;
    }

    public getIndexDoc(aID, aVariableStorage) {
        let wdata: any;
        let wInfo = {
            label: '',
            type: '',
        };
        return this.execUrlAction('getindex',aID).pipe(
            map((data: any) => {
                try {
                    wdata = data;
                    wdata.VariableList.Variable.map((item) => {
                        wInfo = getVariableInfo(aVariableStorage, item.Name);
                        if (wInfo.type === 'DateTime' && Array.isArray(item.Value) === false){
                            item.Value = this.checkFormatDate(item.Value);
                        }
                        item.value = item.Value;
                        item.value = decodeUtf8(item.value);
                        item.Label = wInfo.label;
                        item.type = wInfo.type;
                        item.DefaultValue = item.value;
                        delete item['Value'];
                        delete item['Type'];
                    });
                    return wdata;
                } catch (error) {
                    console.log('getIndexDoc catch', error);
                    return error;
                }
            })
        );
    }

    private checkFormatDate (date) {
        let res = dateFormat(date, 'yyyy-MM-dd');
        if (res !== 'Date invalide'){
            return res
        } else {
            let dateParts = date.split(/[\// :]+/).map(elt => parseInt(elt, 10));
            return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], dateParts[3], dateParts[4], dateParts[5])
        }
    }

    public getTraceDoc(aID) {
        let wdata: any;
        return this.execUrlAction('traces',aID).pipe(
            map((data: any) => {
                wdata = data;
                wdata.TraceList.Trace.forEach((Value) => {
                    Value.Value = decodeUtf8(Value.Value);
                });
                wdata.TraceList.Trace.reverse();
                return wdata;
            })
        );
    }

    public getCommDoc(aID) {
        let wdata: any;
        let wOldUser;
        let wSender;
        return this.execUrlAction('comments',aID).pipe(
            map((data: any) => {
                wdata = data;
                wdata.CommentList.Comment.forEach((Value) => {
                    if (Value.User === wOldUser) {
                        Value['Sender'] = wSender;
                    } else {
                        wSender = !wSender;
                        Value['Sender'] = wSender;
                    }
                    wOldUser = Value.User;
                    Value.User = decodeUtf8(Value.User);
                    Value.Value = decodeUtf8(Value.Value);
                    if (Array.isArray(Value.Date)) {
                        Value.Date = null;
                    }
                });
                wdata.CommentList.Comment.reverse();
                return wdata;
            })
        );
    }

    private getUrlDoc(aAction, aData) {
        const url = {
            getimgbskdef: '/image/basket/default/' + aData + '.png',
            getimgbskcust: '/image/basket/config/' + aData + '.png',
            getimgbtnbsk: '/image/basket/config/' + aData + '.png',
            collectadddoc: '/collect/senddocument',
            senddocument: '/document/senddocument',
            addattachedfile: '/document/addattachedfile',
            setversionnewfile: '/document/setversionnewfile',
            getbackgroundimg: '/image/server/default/' + defBackGround,
            setbackgroundimage: '/config/setbackgroundimage',
            getlogo: '/image/server/default/' + defLogo,
            setlogo: '/config/setlogo'
        }
        return url[aAction];
    }

    public execGetUrlGedAction(aAction, aData) {
        let wUrl;
        wUrl = this.getUrlDoc(aAction, aData);
        return this.comm.getUrlGed() + wUrl;
    }

    public getBasketsDocWithId(aID) {
        let wdata: any;
        return this.execUrlAction('getbaskets',aID).pipe(
            map((data: any) => {
                wdata = data;
                wdata.doc_docid = aID;
                return wdata;
            })
        );
    }

    public getAtfDoc(aID) {
        let wdata: any;
        let wListExt = [...ext_Tiff, ...ext_Images, ...ext_Text, ...ext_Calc, ...ext_Show, ...ext_Mail];   
        let wListVisu = [...ext_Images, ...ext_Pdf, ...ext_Text, ...ext_Calc];
        return this.execUrlAction('getdocatfs',aID).pipe(
            map((data: any) => {
                try {
                    wdata = data;
                    wdata.AtfList.Atf.map((item) => {
                        item.value = '';
                        item.Name = decodeUtf8(item.Name);
                        item.name = item.Name;
                        if (Array.isArray(item.Extension)) {
                            item.Extension = '';
                        } else {
                            item.Extension = item.Extension.toLowerCase();
                        }
                        item.allowCnv = allowConvert(item.Extension, wListExt);
                        item.visu = allowConvert(item.Extension, wListVisu);
                    });
                    return wdata;
                } catch (error) {
                    return error;
                }
            })
        );
    }

    public getVersionList(aID) {
        let wdata: any;
        return this.execUrlAction('getversionlist',aID).pipe(
            map((data: any) => {
                try {
                    wdata = data;
                    wdata.VersionList.Version.map((item) => {
                        item.name = item.Name;
                        item.value = item.name;
                    });
                    return wdata;
                } catch (error) {
                    return error;
                }
            })
        );        
    }

    //Récupération de la liste de toutes les variables d'une bannette
    public getBskVariableList(aBskType, aBskName) {
        let wdata: any;
        const wDataRequest = { 
            baskettype: aBskType, basketname: aBskName };
        return this.execUrlAction('getbskvariablelist', wDataRequest);
    }

    public getBskListByName(aBskType, aBskName) {
        const wDataRequest = { 
            baskettype: aBskType, basketname: aBskName };
        return this.execUrlAction('getbasketlistbyname', wDataRequest);
    }

    //Récupération de la vignette d'un document
    public getThumb(docid, size) {
        return this.comm.getUrlGed() + '/document/' + docid + '/thumbs/' + size + '?' + new Date().getTime();
    }

    public getBinary(id) {
        return this.comm.getUrlGed() + '/config/' + id + '/binary/' + '?' + new Date().getTime();
    }

    //Récupération de la copie PDF d'un document
    public getPdf(aId) {
        return this.comm.getUrlGed() + '/document/' + aId + '/copypdf' + '?' + new Date().getTime();
    }

    public getDocument(aId) {
        return this.comm.getUrlGed() + '/document/' + aId + '/doc' + '?' + new Date().getTime();
    }

    public getRequestPrepare(aAction, aParam) {
        return this.execUrlAction(aAction, aParam).pipe(
            map((data: any) => {
                return {
                    Status: data.Status,
                    data: data.data.map((item: any) => {
                        item.value = item.id;
                        prepareValue(item);
                        return item;
                    })
                }
            })
        );        
    }

    public getResultPrepare(aAction, aParam) {
        return this.execUrlAction(aAction, aParam).pipe(
            map((data: any) => {
                return {
                    Status: data.Status,
                    data: data.data.map((item: any) => {
                        item.value = item.id;
                        prepareResultValue(item);
                        return item;
                    })
                }
            })
        );        
    }

    public createReqBsk(aData, aId, aIdList) {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            id : aId,
            reqlist: getList(aData.requestList),
            bsklist: getList(aData.basketList),
            idlist: aIdList,
        };
        return wRequest;
    }

    public createResBsk(aData, aId, aIdList) {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            id : aId,
            reqlist: aData.requestList,
            bsklist: getList(aData.basketList),
            idlist: aIdList,
        };
        return wRequest;
    }
}
